import React, { useEffect, useRef } from "react"
import { useState } from "react";
import "./style.scss"
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PriceInput from "component/admin/price_input";
import { Button } from "@mui/material";
import { getCategories, getTargets } from "services/user/bookService";
import { IoIosCloseCircle } from "react-icons/io";
// import { LuPlusCircle } from "react-icons/lu";
import { findCategoryIdBySlug, generateSlug } from "utils/createSlug";
import dayjs from 'dayjs';
import { MdCloudUpload, MdDelete } from "react-icons/md";
import { AiFillFileImage } from "react-icons/ai";
import { FiPlusCircle } from "react-icons/fi";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    disableScrollLock: true,
};
  
function getStyles(name, targets, theme) {
    return {
        fontWeight: targets.includes(name)
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
    };
}
const BookInfoForm = ({book, onSubmit}) => {
    const theme = useTheme();
    const [categories, setCategories] = useState([]);
    const [targets, setTargets] = useState([])

    const [categoryVal, setCategoryVal] = useState(0);
    const [targetsVal, setTargetsVal] = useState([]);
    // const [imageUrl, setImageUrl] = useState('');
    const [imageUpload, setImageUpload] = useState(null) // để hiển thị hình ảnh upload
    const [fileNameImage, setFileNameImage] = useState("Không có file được chọn") // lưu tên file hình ảnh upload
    const [fileUpload, setFileUpload] = useState(null) // lưu file ảnh upload để gửi lên server
    const fileInputRef = useRef(null);
    
    const [date, setDate] = useState("")
    const [authors, setAuthors] = useState("");

    const [errors, setErrors] = useState({});

    const handleConfirm = () => {
        const authorValues = inputFields.map(field => field.value).filter(value => value); 
        setAuthors(authorValues.join(", ")); 
        toggleModal();
    };

    const [inputFields, setInputFields] = useState([{value: ""}])
    const handleAddFields = () => {
        setInputFields([...inputFields, { value: "" }]);
    };
    

    const handleRemoveFields = (index) => {
        const newInputFields = [...inputFields];
        newInputFields.splice(index, 1);
        setInputFields(newInputFields);
    };
    
    const handleValueChange = (index, event) => {
        const values = [...inputFields];
        values[index].value = event.target.value;
        setInputFields(values);
    };

    const [modal, setModal] = useState(false);
    const toggleModal = () => {
        setModal(!modal)
    }

    // categories
    useEffect(() => {
        const fetchCategories = async() => {
            try {
                const response = await getCategories();
                setCategories(response.data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    },[])

    //targets
    useEffect(() => {
        const fetchTargets = async () => {
            try {
                const response = await getTargets();
                setTargets(response.data); 
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchTargets();
    }, [])

    // const handleInputChangeImg = (e) => {
    //     setImageUrl(e.target.value);
    // };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileUpload(event.target.files[0])
            setFileNameImage(file.name);
            setImageUpload(URL.createObjectURL(file));
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors }; 
                delete newErrors.file;
                return newErrors;
            });
        }
    };

    const handleChangeDate = (event) => {
        const pad = (num) => num.toString().padStart(2, '0');
        setDate([event["$y"], pad(event["$M"] + 1), pad(event["$D"])].join('-'));
    };
    

    const handleChangeCate = (event) => {
        setCategoryVal(event.target.value);
        if (event.target.value !== 0) {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.category; 
                return newErrors;
            });
        }
    };

    useEffect(() => {
        if (authors.trim() !== "") {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.authors; 
                return newErrors;
            });
        }
    }, [authors]);
    console.log(authors)

    const handleChangeTarget = (event) => {
        const {
          target: { value },
        } = event;
        setTargetsVal(
          typeof value === 'string' ? value.split(',') : value,
        );
        if (value.length > 0) {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.targets; 
                return newErrors;
            });
        }
        console.log(value)
    };

    // khi có book là khi người dùng nhấn chỉnh sửa 1 cuốn sách bất kì
    useEffect(() => {
        if (book) {
            setBookDetails({
                title: book.title || "",
                description: book.description || "",
                originalPrice: book.originalPrice || "",
                discountedPrice: book.discountedPrice || "",
                availableQuantity: book.availableQuantity || 0,
                pages: book.pages || "",
                cover: book.cover || "",
                dimension: book.dimension || "",
                publisherName: book.publisher || "",
                // authors: book.authors || [],
            });
            setImageUpload(book.imageLink)
            setCategoryVal(findCategoryIdBySlug(categories, generateSlug(book.category)))
            setDate(book.datePublish)
            setTargetsVal(book.targets.map(target => target.id))

            setAuthors(book.authors.map(author => author.name).join(", "))
            setInputFields(book.authors.map((author) => ({ value: author.name })))
        }
    }, [categories, book]);

    const [bookDetails, setBookDetails] = useState({
        title: "",
        datePublish: "",
        categoryID: "",
        description: "",
        originalPrice: "",
        discountedPrice: "",
        // imageLink: imageUrl,
        availableQuantity: "",
        pages: "",
        cover: "",
        dimension: "",
        publisherName: "",
        targetIDs: [],
        authors: [],
    })
    
    console.log("bôk", bookDetails)

    // set trạng thái cho các trường không phải input
    useEffect(() => {
        setBookDetails(prev => ({
            ...prev,
            // imageLink: imageUrl, 
            authors: authors.split(",").map(author => author.trim()),
            categoryID: categoryVal,
            targetIDs: targetsVal.map(id => +id),
            datePublish: date
        }));
    }, [authors, categoryVal, targetsVal, date]);

    // set cho các trường là input
    const handleChangeBookDetails = (e) => {
        const name = e.target.name
        const value = e.target.value

        setBookDetails((prev) => {
            return {...prev, [name]: value}
        })

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value) {
                delete newErrors[name];
            } 
            else {
                newErrors[name] = 'Trường này là bắt buộc';  
            }

            if ((name === 'originalPrice' || name === 'discountedPrice')) {
                const originalPrice = Number(bookDetails.originalPrice);
                const discountedPrice = Number(bookDetails.discountedPrice);
                // Xóa lỗi price nếu originalPrice >= discountedPrice hoặc cả hai trường đều trống
                if (
                    (originalPrice >= discountedPrice && discountedPrice > 0 && originalPrice > 0) ||
                    (!bookDetails.originalPrice && !bookDetails.discountedPrice)
                ) {
                    delete newErrors.price;
                } else {
                    newErrors.price = 'Giá gốc phải lớn hơn hoặc bằng giá khi giảm giá';
                }
            }
            return newErrors;
        });
        
    }

    const validateFields = () => {
        const newErrors = {};
    
        if (!fileUpload && !book) {
            newErrors.file = 'Trường này là bắt buộc';
        }
        if (!authors.trim()) {
            newErrors.authors = 'Trường này là bắt buộc'; 
        }
        if (categoryVal === 0) {
            newErrors.category = 'Trường này là bắt buộc';
        }
        if (targetsVal.length === 0) {
            newErrors.targets = 'Vui lòng chọn ít nhất một mục';
        }
        if (bookDetails.originalPrice && bookDetails.discountedPrice) {
            if (Number(bookDetails.originalPrice) < Number(bookDetails.discountedPrice)) {
                newErrors.price = 'Giá gốc phải lớn hơn hoặc bằng giá khi giảm giá';
            }
        }
        Object.keys(bookDetails).forEach((key) => {
            if (!bookDetails[key] && key !== 'datePublish') {
                newErrors[key] = 'Trường này là bắt buộc';
            }
        });
    
        return newErrors;
    };

    const handleDelete = () => {
        setFileUpload(null);
        setFileNameImage("Không có file được chọn");
        setImageUpload(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // onSubmit(bookDetails);
        const newErrors = validateFields();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            
            const firstErrorField = Object.keys(newErrors)[0];
            const firstErrorElement = document.querySelector(`[name="${firstErrorField}"]`);
            if (firstErrorElement) {
                firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } 
        else {
            setErrors({});
            if (book) {
                const formData = new FormData();
                const request = {
                    bookID: book.id,
                    detail: bookDetails
                }
                formData.append('request', new Blob([JSON.stringify(request)], { type: "application/json" }));
                if (fileUpload) {
                    formData.append('image', fileUpload); 
                }
                onSubmit(formData);
            }
            else {
                const formData = new FormData();
                formData.append("bookDetail", new Blob([JSON.stringify(bookDetails)], { type: "application/json" }));
                if (fileUpload) {
                    formData.append('image', fileUpload); 
                }
                onSubmit(formData);
            }
        }
    }
    console.log("lỗi", errors)
    console.log("b", fileUpload)
    
    return (
        <form action="" className="form">
            <div className="card border-0 p-4 mt-5">
                <h5>Hình ảnh của sách</h5>
                <hr />

                <div className="form-group-add_book">
                    <h6>Hình ảnh</h6>
                    {/* <input
                        type="text"
                        placeholder="Nhập URL hình ảnh"
                        name="imageLink"
                        value={bookDetails.imageLink}
                        onChange={handleInputChangeImg}
                        required
                    />
                    
                    {imageUrl && ( 
                        <div className="d-flex justify-content-center mt-3" style={{ height: '400px' }}>
                        <img
                            src={imageUrl}
                            alt="Link hình ảnh không hợp lệ"
                            style={{ 
                                maxWidth: '100%', 
                                height: '100%', 
                                objectFit: 'cover',
                            }}
                        />
                        </div>
                    )} */}

                    <div 
                        className="image_fileUpload"
                        onClick={() => document.querySelector(".input-image").click()}
                    >
                        <input 
                            type="file" accept="image/*" 
                            className="input-image" 
                            name="file" 
                            hidden
                            ref={fileInputRef}
                            onChange={handleFileChange} 
                        />

                        {imageUpload ? (
                            <img src={imageUpload}  style={{ maxWidth: "300px", maxHeight: "300px", objectFit: "contain" }}  alt=""/> 
                        ) : (
                           <>
                                <MdCloudUpload color="#9d2ff7" size={100}/>
                                <p>Chọn file để tải ảnh lên</p>
                           </>
                        )}
                    </div>
                    <section className="d-flex w-100 mt-3">
                        <AiFillFileImage color="#9d2ff7" size={25}/>
                        <span className="ms-auto">
                            {fileNameImage}
                            <MdDelete color="#9d2ff7" size={25} onClick={handleDelete}/>
                        </span>
                    </section>
                    {errors.file && <span className="error">{errors.file}</span>} 
                </div>
            </div>

            <div className="card border-0 p-4 mt-4">
                <h5>Thông tin của sách</h5>
                <hr />

                <div className="form-group-add_book">
                    <h6>Tiêu đề</h6>
                    <input 
                        required
                        type="text" 
                        name="title" 
                        value={bookDetails.title}
                        placeholder="Tên tiêu đề sách"
                        onChange={handleChangeBookDetails}
                        className={errors.title ? 'error' : ''} 
                    />
                    {errors.title && <span className="error">{errors.title}</span>}
                </div>

                <div className="form-group-add_book">
                    <h6>Mô tả</h6>
                    <textarea 
                        name="description" 
                        rows={5} cols={10} 
                        value={bookDetails.description}
                        placeholder="Mô tả sơ lược nội dung về sách..."
                        onChange={handleChangeBookDetails}
                        className={errors.description ? 'error' : ''}
                    />
                    {errors.description && <span className="error">{errors.description}</span>}
                </div>

                <div className="row">
                    <div className="col-6">
                        <div className="form-group-add_book">
                            <h6>Thể loại</h6>
                            <Select
                                className="custom-select"
                                value={categoryVal}
                                onChange={handleChangeCate}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                                MenuProps={{
                                    disableScrollLock: true,
                                    PaperProps: {
                                        style: {
                                            maxHeight: 200, 
                                            overflowY: 'auto',
                                        },
                                    },
                                }}
                                sx={{
                                    '&.MuiOutlinedInput-root': {
                                        // '& fieldset': {
                                        //     borderColor: 'red',
                                        // },
                                        '&:hover fieldset': {
                                            borderColor: '#9d2ff7',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#9d2ff7',
                                        },
                                    },
                                }}
                            >
                                <MenuItem disabled value={0}>
                                    <em>Thể loại</em>
                                </MenuItem>

                                {categories && categories.length > 0 ? (
                                    categories.map(category => (
                                        <MenuItem value={category.id}>{category.name}</MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled>No categories available</MenuItem>
                                )}
                            </Select>
                            {errors.category && <span className="error">{errors.category}</span>} 
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="form-group-add_book">
                            <h6>Đối tượng</h6>
                            <Select
                                className="custom-select"
                                multiple
                                displayEmpty
                                value={targetsVal}
                                onChange={handleChangeTarget}
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <em>Chọn 1 hoặc nhiều đối tượng</em>;
                                    }
                                
                                    return selected.map(id => {
                                        const target = targets.find(t => t.id === id);
                                        return target ? target.name : '';
                                    }).join(', ');
                                }}
                                MenuProps={MenuProps}
                                // style={{ width: '100%', maxWidth: '500px' }}
                                sx={{
                                    '&.MuiOutlinedInput-root': {
                                        // '& fieldset': {
                                        //     borderColor: 'red',
                                        // },
                                        '&:hover fieldset': {
                                            borderColor: '#9d2ff7',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#9d2ff7',
                                        },
                                    },
                                }}
                                inputProps={{ 'aria-label': 'Without label' }}
                                >
                                <MenuItem disabled value="">
                                    <em>Chọn 1 hoặc nhiều đối tượng</em>
                                </MenuItem>
                                {targets && targets.length > 0 ? (
                                    targets.map((target) => (
                                        <MenuItem
                                            key={target.id}
                                            value={target.id}
                                            style={getStyles(target.name, targetsVal, theme)}
                                        >
                                            {target.name}
                                        </MenuItem>
                                    )) 
                                    ) : (
                                        <MenuItem disabled>No targets available</MenuItem>
                                    )
                                }
                            </Select>
                            {errors.targets && <span className="error">{errors.targets}</span>} 
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col">
                        <div className="form-group-add_book">
                            <div className="d-flex">
                                <h6>Tác giả</h6>
                                {/* <Button onClick={toggleModal}>add</Button> */}
                                <FiPlusCircle className="add_author" onClick={toggleModal}/>
                            </div>
                           
                            <input 
                                type="text" 
                                placeholder="Tác giả"
                                value={authors} 
                                readOnly
                                className={errors.authors ? 'error' : ''}
                            />
                            {errors.authors && <span className="error">{errors.authors}</span>}
                        </div>
                    </div>

                    <div className="col">
                        <div className="form-group-add_book">
                            <h6>Nhà xuất bản</h6>
                            <input 
                                type="text" 
                                name="publisherName" 
                                value={bookDetails.publisherName}
                                placeholder="Nhà xuất bản" 
                                onChange={handleChangeBookDetails}
                                className={errors.publisherName ? 'error' : ''}
                            />
                            {errors.publisherName && <span className="error">{errors.publisherName}</span>}
                        </div>
                    </div>
                </div>

                {modal && (
                    <div className="modal">
                        <div className="overlay">
                            <div className="modal-content1">
                                <div className="d-flex">
                                    <h5>Thêm tác giả</h5>
                                    <IoIosCloseCircle className="close-modal ms-auto" onClick={toggleModal}/>
                                </div>

                                {inputFields.map((inputField, index) => (
                                    <div className="input-container" key={index}>
                                        <input
                                            type="text"
                                            placeholder="Nhập tên tác giả"
                                            value={inputField.value}
                                            onChange={(e) => handleValueChange(index, e)}
                                        />

                                        <Button className="delete-btn" onClick={() => handleRemoveFields(index)}>
                                            <span class="material-symbols-outlined delete-icon">Xoá</span>
                                        </Button>
                                    </div>
                                ))}
                                
                                <div className="d-flex">
                                    <Button className="add-btn" onClick={handleAddFields}>
                                        Thêm
                                    </Button>
                                    <Button className="add-btn ms-auto" onClick={handleConfirm}>Lưu</Button>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                )} 

                <div className="row mt-1">
                    <div className="col">
                        <div className="form-group-add_book">
                            <h6>Số lượng sách</h6>
                            <input 
                                type="number" 
                                name="availableQuantity" 
                                value={bookDetails.availableQuantity}
                                placeholder="Số lượng sách hiện có trong kho" 
                                min="0" 
                                onChange={handleChangeBookDetails}
                                className={errors.availableQuantity ? 'error' : ''}
                            />
                            {errors.availableQuantity && <span className="error">{errors.availableQuantity}</span>}
                        </div>
                    </div>

                    <div className="col">
                        <div className="form-group-add_book">
                            <h6>Số trang</h6>
                            <input 
                                type="text" 
                                name="pages" 
                                value={bookDetails.pages}
                                placeholder="Số trang sách" 
                                min="0" 
                                onChange={handleChangeBookDetails}
                                className={errors.pages ? 'error' : ''}
                            />
                            {errors.pages && <span className="error">{errors.pages}</span>}
                        </div>
                    </div>
                    
                    <div className="col">
                        <div className="form-group-add_book">
                            <h6>Định dạng</h6>
                            <input 
                                type="text" 
                                name="cover" 
                                value={bookDetails.cover}
                                placeholder="Ex: bìa mềm, bìa cứng,..." 
                                onChange={handleChangeBookDetails}
                                className={errors.cover ? 'error' : ''}
                            />
                            {errors.cover && <span className="error">{errors.cover}</span>}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <h6 className="mb-0">Ngày phát hành</h6>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                    value={dayjs(date)}
                                    format="DD/MM/YYYY"
                                    onChange={handleChangeDate}
                                    sx={{
                                        width: '100%',
                                        height: 40,
                                        '& .MuiInputBase-input': {
                                            height: '40px',
                                            padding: '0px 10px',
                                            borderRadius: '8px'
                                        },
                                        '&:hover': {
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#9d2ff7',
                                            },
                                        },
                                    }}   
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>


                    <div className="col">  
                        <div className="form-group-add_book">
                            <h6>Khuôn khổ</h6>
                            <input 
                                type="text" 
                                name="dimension" 
                                value={bookDetails.dimension}
                                placeholder="11x13cm"
                                onChange={handleChangeBookDetails}
                                className={errors.dimension ? 'error' : ''}
                            />
                            {errors.dimension && <span className="error">{errors.dimension}</span>}
                        </div>

                    </div>
                </div>
            </div>

            <div className="card border-0 p-4 mt-4 mb-5">
                <h5>Thông tin về giá</h5>
                <hr />

                <div className="row">
                    <div className="col">
                        <div className="form-group-add_book">
                            <h6>Giá gốc</h6>
                            <div className="input-price-container d-flex">
                                <span>VND</span>
                                <input
                                    className={`input-price ${errors.originalPrice ? 'error' : ''}`} 
                                    type="number"
                                    name="originalPrice" 
                                    value={bookDetails.originalPrice}
                                    onChange={handleChangeBookDetails}
                                />
                            </div>
                            {errors.originalPrice && <span className="error">{errors.originalPrice}</span>}
                            {/* <PriceInput 
                                value={priceOrigin}
                                ref={oriPriceInputRef} 
                                onChange={handleOriPriceChange} 
                            /> */}
                        </div>
                    </div>
                    
                    <div className="col">
                         <div className="form-group-add_book">
                            <h6>Giá khi giảm giá</h6>
                            <div className="input-price-container d-flex">
                                <span>VND</span>
                                <input
                                    className={`input-price ${errors.discountedPrice ? 'error' : ''}`} 
                                    type="number"
                                    name="discountedPrice" 
                                    value={bookDetails.discountedPrice}
                                    onChange={handleChangeBookDetails}
                                />
                            </div>
                            {errors.discountedPrice && <span className="error">{errors.discountedPrice}</span>}
                            {/* <PriceInput ref={discountPriceInputRef} onChange={handleDiscountPriceChange}/> */}
                        </div>
                    </div>
                    {errors.price && <span style={{ color: 'red', fontSize: '13px' }}>{errors.price}</span>}
                </div>
            </div>

            <Button 
                className="addSubmit"
                onClick={handleSubmit} 
            >
                {book ? 'Chỉnh sửa sách' : 'Thêm sách'}
            </Button>
        </form>
    )
}

export default BookInfoForm;